import { DefaultPrivacyLevel } from "@datadog/browser-rum";

export const environment = {
  production: false,
  API_BASE_URL: 'https://qa.qrscanning.farmrise.bayer.com/v1/qr/scan/validate',
  username: '52783b2a-30fb-4b87-80de-6e15f7250c5a',
  password: '9c75d2cda5fde9ed9d3445738f1915f0',
  appDownloadCardDynamicLink: 'https://farmrisetest.page.link/e5sG',
  appDownloadBottomBannerDynamicLink: 'https://farmrisetest.page.link/E1Cv',
  appDownloadBottomSheetDynamicLink: 'https://farmrisetest.page.link/s7f7',
  firebase: {
    projectId: 'qrscan-spa-stage',
    appId: '1:157222297830:web:d0c0bcee005528fad81b27',
    storageBucket: 'qrscan-spa-stage.firebasestorage.com',
    apiKey: 'AIzaSyCe_2ffjDYE5Ed5FswvJBx0vjAdtgJdi_w',
    authDomain: 'qrscan-spa-stage.firebaseapp.com',
    messagingSenderId: '157222297830',
    measurementId: 'G-D87EVE3EPE'
  },
  datadog: {
    applicationId: 'b9206f2f-bc23-4169-8b81-a6065e511938',
    clientToken: 'pub9899efb4d12ff3ea988f9555a4a474fe',
    site: 'datadoghq.com',
    service: 'farmrise-qr-spa',
    env: 'qa',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
  }
};
